export default function ProductDetailsHeader({ title = "Product Details", breadcrumbs = [] }) {
  return null;
}
